import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="32" viewbox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.57 22.37a4.53 4.53 0 0 1-4.524 4.524H1.432V8.977a4.53 4.53 0 0 1 4.524-4.524h24.613V22.37Z" fill="#fff"></path><path d="M22.554 17.778h1.87c.054 0 .178-.018.232-.018a.834.834 0 0 0 .659-.837.864.864 0 0 0-.66-.837c-.053-.018-.16-.018-.23-.018h-1.87v1.71Z" fill="url(#jcb-a)"></path><path d="M24.21 5.97a3.242 3.242 0 0 0-3.242 3.24v3.367h4.578c.106 0 .231 0 .32.018 1.033.053 1.799.587 1.799 1.513 0 .73-.517 1.354-1.478 1.479v.035c1.05.072 1.852.66 1.852 1.568 0 .98-.89 1.62-2.066 1.62H20.95v6.59h4.756a3.242 3.242 0 0 0 3.241-3.241V5.969H24.21Z" fill="url(#jcb-b)"></path><path d="M25.083 14.322a.758.758 0 0 0-.659-.766c-.035 0-.124-.018-.178-.018h-1.692v1.567h1.692c.054 0 .16 0 .178-.017a.758.758 0 0 0 .66-.766Z" fill="url(#jcb-c)"></path><path d="M6.294 5.97a3.242 3.242 0 0 0-3.242 3.24v7.997c.909.446 1.853.73 2.797.73 1.122 0 1.727-.676 1.727-1.602v-3.776h2.779v3.758c0 1.46-.909 2.654-3.99 2.654-1.87 0-3.33-.41-3.33-.41v6.821H7.79a3.242 3.242 0 0 0 3.241-3.241V5.969H6.294Z" fill="url(#jcb-d)"></path><path d="M15.252 5.97a3.242 3.242 0 0 0-3.241 3.24v4.24c.819-.695 2.244-1.14 4.541-1.034 1.23.054 2.547.392 2.547.392v1.372c-.659-.339-1.442-.641-2.458-.713-1.745-.124-2.796.73-2.796 2.227 0 1.513 1.051 2.368 2.796 2.226 1.016-.071 1.8-.392 2.458-.713v1.372s-1.3.338-2.547.392c-2.297.107-3.722-.339-4.541-1.033v7.48h4.755a3.242 3.242 0 0 0 3.242-3.241V5.969h-4.756Z" fill="url(#jcb-e)"></path><defs><linearGradient id="jcb-a" x1="20.966" y1="16.925" x2="28.97" y2="16.925" gradientUnits="userSpaceOnUse"><stop stop-color="#007940"></stop><stop offset=".229" stop-color="#00873F"></stop><stop offset=".743" stop-color="#40A737"></stop><stop offset="1" stop-color="#5CB531"></stop></linearGradient><linearGradient id="jcb-b" x1="20.965" y1="15.677" x2="28.969" y2="15.677" gradientUnits="userSpaceOnUse"><stop stop-color="#007940"></stop><stop offset=".229" stop-color="#00873F"></stop><stop offset=".743" stop-color="#40A737"></stop><stop offset="1" stop-color="#5CB531"></stop></linearGradient><linearGradient id="jcb-c" x1="20.966" y1="14.319" x2="28.97" y2="14.319" gradientUnits="userSpaceOnUse"><stop stop-color="#007940"></stop><stop offset=".229" stop-color="#00873F"></stop><stop offset=".743" stop-color="#40A737"></stop><stop offset="1" stop-color="#5CB531"></stop></linearGradient><linearGradient id="jcb-d" x1="3.049" y1="15.677" x2="11.176" y2="15.677" gradientUnits="userSpaceOnUse"><stop stop-color="#1F286F"></stop><stop offset=".475" stop-color="#004E94"></stop><stop offset=".826" stop-color="#0066B1"></stop><stop offset="1" stop-color="#006FBC"></stop></linearGradient><linearGradient id="jcb-e" x1="11.965" y1="15.677" x2="19.858" y2="15.677" gradientUnits="userSpaceOnUse"><stop stop-color="#6C2C2F"></stop><stop offset=".173" stop-color="#882730"></stop><stop offset=".573" stop-color="#BE1833"></stop><stop offset=".859" stop-color="#DC0436"></stop><stop offset="1" stop-color="#E60039"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
